import {themeRP} from "@pg-design/themes";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IPaginatedResponse} from "../../request/IResponse";
import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";

export interface IRegionsDetailsResponse extends IPaginatedResponse {
    results: IRegionListRegion[];
}

export interface IMapCircle {
    center: {
        lat: number;
        lng: number;
    };
    radius: number;
    pathOptions: {
        color: string;
        opacity: number;
    };
}

export const fetchRegionsCircles = (regionsIds: number[]) => {
    const url = appendQueryString(apiV2ListLink.region.list(Scenario.REGION_DETAIL), {region: regionsIds});

    if (!regionsIds.length) {
        return [];
    }

    return getRequest({}, url).then((json: IRegionsDetailsResponse) => {
        return json.results.map(({area: {center, radius}}) => ({
            center: {
                lat: center.lat,
                lng: center.lon
            },
            radius: radius || 10_000,
            pathOptions: {
                color: themeRP.colors.primary,
                opacity: 0.3
            }
        }));
    });
};
import {themeRP} from "@pg-design/themes";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IPaginatedResponse} from "../../request/IResponse";
import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";

export interface IRegionsDetailsResponse extends IPaginatedResponse {
    results: IRegionListRegion[];
}

export interface IMapCircle {
    center: {
        lat: number;
        lng: number;
    };
    radius: number;
    pathOptions: {
        color: string;
        opacity: number;
    };
}

export const fetchRegionsCircles = (regionsIds: number[]) => {
    const url = appendQueryString(apiV2ListLink.region.list(Scenario.REGION_DETAIL), {region: regionsIds});

    if (!regionsIds.length) {
        return [];
    }

    return getRequest({}, url).then((json: IRegionsDetailsResponse) => {
        return json.results.map(({area: {center, radius}}) => ({
            center: {
                lat: center.lat,
                lng: center.lon
            },
            radius: radius || 10_000,
            pathOptions: {
                color: themeRP.colors.primary,
                opacity: 0.3
            }
        }));
    });
};
